// Amounts travel as integers in minor units + an ISO-4217 code (see backend
// core/money.py). The number of decimals comes from Intl, so a new currency
// needs no code change here.
export function fractionDigits(currency: string): number {
  return new Intl.NumberFormat('en', { style: 'currency', currency }).resolvedOptions().maximumFractionDigits ?? 2;
}

export function fromMinor(amount: number, currency: string): number {
  return amount / 10 ** fractionDigits(currency);
}

export function toMinor(value: number | string, currency: string): number {
  const num = typeof value === 'string' ? Number(value.replace(',', '.')) : value;
  return Math.round((Number.isFinite(num) ? num : 0) * 10 ** fractionDigits(currency));
}

export function formatMoney(amount: number | null | undefined, currency: string, locale = 'en'): string {
  if (amount == null) return '—';
  const digits = fractionDigits(currency);
  // Whole amounts without decimals ($180), otherwise all of them ($737.20).
  const whole = amount % 10 ** digits === 0;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: whole ? 0 : digits,
    minimumFractionDigits: whole ? 0 : digits,
  }).format(fromMinor(amount, currency));
}
